import { omitBookingFormUiFields } from "./omitBookingFormUiFields";

type BookingDetailsLike = {
  tenantDetails?: { tenantIdentityType?: string };
};

export const buildBookingStepPayload = <TStepBody extends Record<string, unknown>>(
  bookingForm: Record<string, unknown> | undefined,
  bookingDetails: BookingDetailsLike | undefined,
  stepBody: TStepBody,
): TStepBody & Record<string, unknown> & { tenantIdentityType?: string } => {
  const tenantIdentityType = bookingDetails?.tenantDetails?.tenantIdentityType;

  return {
    ...omitBookingFormUiFields(bookingForm ?? {}),
    ...(tenantIdentityType ? { tenantIdentityType } : {}),
    ...stepBody,
  } as TStepBody & Record<string, unknown> & { tenantIdentityType?: string };
};
